import styled, { css } from 'styled-components';
import { lighten } from 'polished';

export const SidebarContainer = styled.aside`
  width: 280px;
  height: 97vh;
  background-color: #262731;
  color: #ecf0f1;
  padding: 20px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 800px) {
    display: none;
  }

  .logo {
    width: 80%;
    margin-bottom: 20px;
  }

  .interview-list {
    list-style: none;
    padding: 0;
    width: 100%;
  }

  .interview-list li {
    margin-bottom: 10px;
    width: 100%;
  }

  .interview-link {
    text-decoration: none;
    color: #ecf0f1;
    font-weight: bold;
    display: block;
    padding: 10px;
    text-align: left;
    border-radius: 4px;
    transition: background-color 0.3s ease;
  }

  .interview-link.selected,
  .interview-link:hover {
    background-color: ${lighten(0.1, '#2c3e50')};
  }
`;
